module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAGklEQVR4nGNggIKNKxf/BxMwzHDv1o7/MFkAJf8PYGxvIrIAAAAASUVORK5CYII="